"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTEXT_OPTIONS = void 0;
exports.resolveBlocksForDate = resolveBlocksForDate;
exports.getPatientBlocks = getPatientBlocks;
exports.addPatientBlock = addPatientBlock;
exports.updatePatientBlock = updatePatientBlock;
exports.deletePatientBlock = deletePatientBlock;
exports.getPatientServiceMode = getPatientServiceMode;
exports.setPatientServiceMode = setPatientServiceMode;
/**
 * Patient Availability Service
 * Manages per-patient unavailable blocks and service mode via PatientAvailability namespace.
 * Backend: SqlClass → processClass → tswebhook (PatientAvailability.*)
 */
var axios_1 = require("axios");
var apis_1 = require("@/constants/apis");
// Context label options per service mode
exports.CONTEXT_OPTIONS = {
    in_home: [
        'Personal Routine',
        'Social Presence',
        'Unavailable / Private',
        'Meals & Nutrition',
        'Out of Home',
        'Sleep / Rest'
    ],
    inpatient: [
        'Procedure / In OR',
        'Imaging',
        'ICU Restriction',
        'Family Not Allowed'
    ],
    clinic: [
        'Appointment Slot',
        'Telehealth Window',
        'Patient Preference'
    ]
};
// Resolve which blocks from a list apply on a given date (client-side, no round-trip)
function resolveBlocksForDate(blocks, dateStr) {
    var date = new Date(dateStr + 'T00:00:00');
    var dow = date.getDay();
    return blocks
        .filter(function (b) {
        if (b.recurrence_type === 'daily')
            return true;
        if (b.recurrence_type === 'weekly')
            return b.recurrence_day === dow;
        if (b.recurrence_type === 'none')
            return b.specific_date === dateStr;
        return false;
    })
        .sort(function (a, b) { return a.start_time.localeCompare(b.start_time); });
}
function getPatientBlocks(accountnumber, patientId, serviceMode) {
    return __awaiter(this, void 0, Promise, function () {
        var payload, res, rows, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    payload = {
                        PatientAvailability: { API_Meth: 'GetBlocks', accountnumber: accountnumber, patientId: patientId, serviceMode: serviceMode }
                    };
                    console.log('getPatientBlocks request', payload);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', payload, {
                            headers: { 'Content-Type': 'application/json;' }
                        })];
                case 2:
                    res = _b.sent();
                    console.log('getPatientBlocks response', res.data);
                    rows = (_a = res.data) === null || _a === void 0 ? void 0 : _a.records;
                    return [2 /*return*/, Array.isArray(rows) ? rows : []];
                case 3:
                    err_1 = _b.sent();
                    console.log('getPatientBlocks error', err_1);
                    return [2 /*return*/, []];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function addPatientBlock(accountnumber, patientId, serviceMode, block) {
    return __awaiter(this, void 0, Promise, function () {
        var payload, res, err_2;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    payload = {
                        PatientAvailability: {
                            API_Meth: 'AddBlock',
                            accountnumber: accountnumber,
                            patientId: patientId,
                            serviceMode: serviceMode,
                            contextLabel: block.contextLabel,
                            startTime: block.startTime,
                            endTime: block.endTime,
                            exclusivity: block.exclusivity,
                            recurrenceType: block.recurrenceType,
                            recurrenceDay: (_a = block.recurrenceDay) !== null && _a !== void 0 ? _a : null,
                            specificDate: (_b = block.specificDate) !== null && _b !== void 0 ? _b : null,
                            notes: (_c = block.notes) !== null && _c !== void 0 ? _c : null
                        }
                    };
                    console.log('addPatientBlock request', payload);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', payload, {
                            headers: { 'Content-Type': 'application/json;' }
                        })];
                case 2:
                    res = _e.sent();
                    console.log('addPatientBlock response', res.data);
                    return [2 /*return*/, ((_d = res.data) === null || _d === void 0 ? void 0 : _d.code) === 1
                            ? { success: true, id: Number(res.data.id) }
                            : { success: false }];
                case 3:
                    err_2 = _e.sent();
                    console.log('addPatientBlock error', err_2);
                    return [2 /*return*/, { success: false }];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function updatePatientBlock(accountnumber, id, block) {
    return __awaiter(this, void 0, Promise, function () {
        var payload, res, err_3;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    payload = {
                        PatientAvailability: {
                            API_Meth: 'UpdateBlock',
                            accountnumber: accountnumber,
                            id: id,
                            contextLabel: block.contextLabel,
                            startTime: block.startTime,
                            endTime: block.endTime,
                            exclusivity: block.exclusivity,
                            recurrenceType: block.recurrenceType,
                            recurrenceDay: (_a = block.recurrenceDay) !== null && _a !== void 0 ? _a : null,
                            specificDate: (_b = block.specificDate) !== null && _b !== void 0 ? _b : null,
                            notes: (_c = block.notes) !== null && _c !== void 0 ? _c : null
                        }
                    };
                    console.log('updatePatientBlock request', payload);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', payload, {
                            headers: { 'Content-Type': 'application/json;' }
                        })];
                case 2:
                    res = _e.sent();
                    console.log('updatePatientBlock response', res.data);
                    return [2 /*return*/, { success: ((_d = res.data) === null || _d === void 0 ? void 0 : _d.code) === 1 }];
                case 3:
                    err_3 = _e.sent();
                    console.log('updatePatientBlock error', err_3);
                    return [2 /*return*/, { success: false }];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function deletePatientBlock(accountnumber, id) {
    return __awaiter(this, void 0, Promise, function () {
        var payload, res, err_4;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    payload = {
                        PatientAvailability: { API_Meth: 'DeleteBlock', accountnumber: accountnumber, id: id }
                    };
                    console.log('deletePatientBlock request', payload);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', payload, {
                            headers: { 'Content-Type': 'application/json;' }
                        })];
                case 2:
                    res = _b.sent();
                    console.log('deletePatientBlock response', res.data);
                    return [2 /*return*/, { success: ((_a = res.data) === null || _a === void 0 ? void 0 : _a.code) === 1 }];
                case 3:
                    err_4 = _b.sent();
                    console.log('deletePatientBlock error', err_4);
                    return [2 /*return*/, { success: false }];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getPatientServiceMode(accountnumber, patientId) {
    return __awaiter(this, void 0, Promise, function () {
        var payload, res, _a;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    payload = {
                        PatientAvailability: { API_Meth: 'GetServiceMode', accountnumber: accountnumber, patientId: patientId }
                    };
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', payload, {
                            headers: { 'Content-Type': 'application/json;' }
                        })];
                case 2:
                    res = _d.sent();
                    return [2 /*return*/, (_c = (_b = res.data) === null || _b === void 0 ? void 0 : _b.service_mode) !== null && _c !== void 0 ? _c : 'in_home'];
                case 3:
                    _a = _d.sent();
                    return [2 /*return*/, 'in_home'];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function setPatientServiceMode(accountnumber, patientId, serviceMode) {
    return __awaiter(this, void 0, Promise, function () {
        var payload, err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = {
                        PatientAvailability: { API_Meth: 'SetServiceMode', accountnumber: accountnumber, patientId: patientId, serviceMode: serviceMode }
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', payload, {
                            headers: { 'Content-Type': 'application/json;' }
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_5 = _a.sent();
                    console.log('setPatientServiceMode error', err_5);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
